<template>
  <div>
    <base-header type="gray-100" class="pb-6 pb-8 pt-5 pt-md-5"> </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12 order-xl-1" :class="{loading: loading}">
          <slide-x-left-transition
            :duration="200"
            mode="out-in"
            origin="center top"
            v-if="laboratorio"
          >
            <form @submit.prevent>
              <h2>{{formatarData(data)}} - Solicitação Nº {{numero}}</h2>
              <card shadow type="secondary">
                <div class="row">
                  <div class="col-8">
                    <h6 class="heading-small text-muted mb-1">
                      {{ laboratorio.nomeFantasia }}
                    </h6>
                    <h6 class="heading-small text-muted mb-4">
                      Responsável Técnico: {{ laboratorio.nomeResponsavel }} - CRO
                      {{ laboratorio.croResponsavel }}
                    </h6>
                  </div>
                  <div class="col-4 d-flex flex-column align-items-end justify-content-start text-right data">
                    <badge class="mb-2" :type="coresStatus[status]">
                      {{nomeStatus(status)}}
                    </badge>
                  </div>
                </div>
                <flow-form :campos="campos">
                  <div slot="dente">
                    <div class="selecaoDente row justify-content-center">
                      <template v-for="(area, ai) in campos.dente.opcoesDentes">
                        <div
                          class="area row m-2"
                          :class="{ baixo: ai > 1 }"
                          :key="'area_dente_' + ai"
                        >
                          <span
                            class="dente d-center clickable"
                            :class="[{
                              selecionado: denteSelecionado(dente),
                            },denteAgrupado(dente)]"
                            @click="selecionarDente(dente)"
                            v-for="dente in area"
                            :key="'dente_' + dente"
                            >{{ dente }}</span
                          >
                        </div>
                        <div
                          class="break col-12"
                          :key="'justa_break' + ai"
                          v-if="ai == 1"
                        ></div>
                      </template>
                    </div>
                    <div class="dentesSelecionados mt-4">
                      <template v-for="dente in campos.dente.value">
                          <template v-if="Array.isArray(dente)">
                            <div
                              class="denteSel mt-2"
                              :key="'dente_' + idGrupo(dente)"
                            >
                              <div class="nmDente py-3 row align-items-center justify-content-center mx-0">
                                <span title="Estes dentes estão agrupados" class="corGrupo" :class="denteAgrupado(dente[0].numero)"></span>
                                {{nomeGrupo(dente)}}
                              </div>
                              <flow-form :campos="dente[0]" />
                            </div>
                          </template>
                          <template v-else>
                            <div
                              class="denteSel mt-2"
                              :key="'dente_' + dente.numero"
                            >
                              <div class="nmDente py-3">Dente {{ dente.numero }}</div>
                              <flow-form :campos="dente" />
                            </div>
                          </template>
                        </template>
                    </div>
                  </div>
                </flow-form>
                <div class="files" v-if="arquivos">
                    <label class="form-control-label">Arquivos - Anexados pelo Dentista</label> 
                    <ul>
                      <li v-for="(arquivo, key) in arquivos" :key="key">
                          <a :href="storage_url + '/storage/' + arquivo.file" title="Abrir Arquivo" target="_blank">{{arquivo.name}}</a>
                      </li>
                    </ul>
                </div>

                 <div class="files" v-if="arquivos2">
                    <label class="form-control-label">Arquivos - Anexados pelo Laboratório</label> 
                    <ul>
                      <li v-for="(arquivo, key) in arquivos2" :key="key">
                          <a :href="storage_url + '/storage/' + arquivo.file" title="Abrir Arquivo" target="_blank">{{arquivo.name}}</a>
                      </li>
                    </ul>
                </div>
              </card>
            </form>
          </slide-x-left-transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FlowForm from "@/components/cflow/FlowForm";
import formMinhaSolicitacao from "@/forms/verMinhaSolicitacao"
import helpers from "@/cflow/helpers";
import ordens from "@/cflow/ordens.js";
import parametros from "@/cflow/parametros.js";
import config from 'config';
import { SlideXLeftTransition, SlideXRightTransition } from "vue2-transitions";

var solicitarOrdem = {
  components: {
    FlowForm,
    SlideXLeftTransition,
    SlideXRightTransition,
  },
  computed: {
  },
  methods: {
    nomeStatus: function(status) {
      for(let item of this.todosStatus){
        if(item.valor == status) return item.nome;
      }
    },
    nomeGrupo(grupo) {
      if(!grupo) return ''
       let label = 'Dente';
      if(grupo.length > 1) label + 's';
      let nome = grupo.map(item => { return item.numero })
      let last = nome.length > 1 ? nome.pop() : ''
      return label + ' ' + nome.join(', ') + (last ? ' e ' + last : '');
    },
    idGrupo(grupo) {
      if(!grupo) return ''
      let id = grupo.map(item => { return item.numero })
      return id.join('-')
    },
    denteSelecionado(dente) {
      // Verifica se um dente está selecionado
      const fonte = this.agrupando ? this.grupoTMP : this.campos.dente.value
      return fonte.map(item => { return item.numero }).includes(dente)
    },
    denteAgrupado(dente) {
      // Verifica se um dente é agrupado e dá pra ele a classe com seu número do grupo.
      var num = 0
      var minhaClasse = null
      this.campos.dente.value.some(d => {
        if(Array.isArray(d)){
          // Se for um array de dentes
          d.forEach(sd => {
            // Verificar cada filho

            if(sd.numero === dente) {
              minhaClasse = 'selecionado borda-'+ (num % 5) // o número, num intervalo de 0 a 5, 6 = 0, 7 = 1, etc...
              return true
            }
          })
        }
        num++
      })
      return minhaClasse
    }
  },
  mounted: function () {
    if (this.$route.params.id) {
      this.loading = true;
      Promise.all([ordens.detalhes(this.$route.params.id),parametros.params(['status'])]).then( res => {
        if(res[0]){
          this.laboratorio = res[0].laboratorio;
          this.dentista = res[0].dentista;
          this.data = res[0].created_at;
          this.numero = res[0].id;
          this.status = res[0].status
          this.arquivos = res[0].arquivos;
          this.arquivos2 = res[0].arquivos2;
          this.storage_url = config[process.env.NODE_ENV].api.endpoint;
          if (this.dentista.id) {
            this.campos.dr.value = this.dentista.nome;
          }
          helpers.preencherCampos(this.campos, res[0]);
        }
        this.todosStatus = res[1].status;
        this.loading = false;
      })
    }
  },
  data() {
    return {
      etapa: 0,
      status: [],
      laboratorio: null,
      dentista: {},
      laboratorios: [],
      data: null,
      coresStatus: ['default','info','primary','info','info','success','danger','danger'],
      loading: false,
      campos: formMinhaSolicitacao
    };
  },
};
export default solicitarOrdem;
</script>
<style lang="scss" scoped>
.dente {
  width: 35px;
  height: 45px;
  padding-top: 10px;
  border-radius: 70%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin: 2px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  transition: 0.2s;
  &.selecionado{
    border-color: #000;
    transform: translate3d(0, 10%, 0);
    box-shadow: 0 -5px 3px rgba(0, 0, 0, 0.15);
  }
}
.dente:hover {
  transform: translate3d(0, 10%, 0);
}
.baixo .dente {
  border-radius: 70%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding-top: 0;
  padding-bottom: 10px;
  &.selecionado{
    transform: translate3d(0, -10%, 0);
    box-shadow: 0 5px 3px rgba(0, 0, 0, 0.15);
  }
}
.baixo .dente:hover {
  transform: translate3d(0, -10%, 0);
}
.dentesSelecionados .denteSel .nmDente {
  background: #e0e0e0;
  background: -moz-linear-gradient(top, #e0e0e0 0%, #f7f7f7 100%);
  background: -webkit-linear-gradient(top, #e0e0e0 0%, #f7f7f7 100%);
  background: linear-gradient(to bottom, #e0e0e0 0%, #f7f7f7 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e0e0e0', endColorstr='#f7f7f7',GradientType=0 );

  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  width: auto;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 0.1rem;
  text-align: center;
  margin-bottom: 10px;
  position: relative;

  .corGrupo{
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 2px solid #000;
    align-self: center;
    margin-right: 5px;
  }

  .remover{
    position: absolute;
    right: 15px;
    padding: 10px;
    box-shadow: inset 0 1px 5px rgba(0,0,0,0.2);
    border-radius: 50px;
    transition: 0.1s;
    z-index: 2;
    text-align: center;

    &:active{
      box-shadow: inset 0 2px 8px rgba(0,0,0,0.2);
    }
    span{
      margin-left: 1px;
    }
  }
}
@media all and (max-width: 500px) {
  .dente {
    max-width: calc(12.5% - 4px);
  }
  .break {
    height: 50px;
  }
}
.listaLaboratorios .lab{
  min-width: 200px;
}
.agrupar{
  ::v-deep label{
    font-size: 1.3rem!important;
    line-height: 1.45rem;
  }
}

.borda-0{
  border-color: rgb(59, 137, 211)!important;
}
.borda-1{
  border-color: rgb(116, 189, 113)!important;
}
.borda-2{
  border-color: rgb(169, 133, 204)!important;
}
.borda-3{
  border-color: rgb(213, 214, 125)!important;
}
.borda-4{
  border-color: rgb(228, 133, 133)!important;
}
.files ul li a {
  text-transform: uppercase;
  font-size: 12px;
  display: inline-block;
  padding: 5px 0;
}
.files ul li a:hover{
  text-decoration: underline;
}
</style>
